import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import Editor, { useMonaco }  from "@monaco-editor/react";
import { ReactComponent as LeftIcon } from "../../../../../assets/svg/left-arrow.svg";
import {
    BoldIcon,
    ItalicIcon,
    StrikeIcon,
    OrderedListIcon,
    UnorderedListIcon,
    LinkIcon,
    CodeIcon,
    TableIcon,
} from "./asset/MarkdownIcon";
import SplitPane, { Pane } from "../../../../../plugin/react-split-pane";
import TarsChatBot from "../../../Assisted/forms/create/properties/TarsChatBot";
import TarsIcon from '../../../../../assets/images/tarsIcon.png'
interface IProps {
    close: () => void;
    onChange: (value: any) => void;
    editorContext: {
        visibility: boolean;
        type: string;
        source: string;
        where: string;
    };
    isCheckedIn: boolean;
    customdef?: any;
}

export const MarkdownEditor: React.FC<IProps> = ({
    isCheckedIn,
    close,
    editorContext,
    customdef,
    onChange,
}) => {
    const { source, where, type, visibility} = editorContext;
    const [markdownData, setMarkdownData] = useState("");

    useEffect(() => {
        setMarkdownData(editorContext.source);
    }, [editorContext]);
    const [isVisibleTars, setIsVisibleTars] = useState<boolean>(true)

    return (
        <div
            title="Markdown_editor"
            key="click-code-editor"
            style={{ position: "fixed", zIndex: 999, top: '0px', width: "100%", height: "100vh", right: "0px", padding: "0px", margin: "0px", maxWidth: "100%" }}
        >
            <div style={{ height: "100%", width: "100%", display: "flex", background: "white" }}>
                <SplitPane className={""} paneStyle={{ width: window.innerWidth + "px" }} >
                    <Pane className={' override-component-pane'} minSize={!isVisibleTars ? "100%" : "40%"} initialSize={!isVisibleTars ? "100%" : "60%"} maxSize={!isVisibleTars ? "100%" : "80%"}>
                        <div
                            style={{
                                backgroundColor: "#1212123d",
                                height: "100%",
                                width: "100%",
                                fontSize: 14,
                                zIndex: 999,
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#FCFCFC",
                                    height: "100%",
                                    width: "100%",
                                }}
                            >
                                <Header
                                    markdownData={markdownData}
                                    isCheckedIn={isCheckedIn}
                                    close={close}
                                    editorContext={editorContext}
                                    onChange={onChange}
                                    type={type}
                                    setIsVisibleTars={setIsVisibleTars}
                                    isVisibleTars={isVisibleTars}
                                />
                                {visibility && (
                                    <EditorPanel
                                        customdef={customdef}
                                        isCheckedIn={isCheckedIn}
                                        source={source}
                                        type={type}
                                        where={where}
                                        close={close}
                                        setMarkdownData={setMarkdownData}
                                    />
                                )}
                            </div>
                        </div>
                    </Pane>
                    {isVisibleTars &&
                        <Pane className={' override-component-pane'} minSize="30%" initialSize="40%" maxSize="60%">
                            <TarsChatBot editorRef={customdef} type={"inline"} setIsVisibleTars={setIsVisibleTars} ></TarsChatBot>
                        </Pane>}
                </SplitPane>
            </div>
        </div>
    );
};

interface IHeader {
    close: () => void;
    isCheckedIn: boolean;
    onChange: (value: any) => void;
    type: string;
    markdownData: any;
    setIsVisibleTars: (value: boolean) => void;
    isVisibleTars: boolean;
    editorContext: {
        visibility: boolean;
        type: string;
        source: string;
        where: string;
    };
}

const Header: React.FC<IHeader> = ({
    isCheckedIn,
    close,
    onChange,
    markdownData,
    setIsVisibleTars,
    isVisibleTars
}) => {
    return (
        <div
            className="flex items-center justify-between"
            style={{ backgroundColor: "#2239790F", padding: "12px" }}
        >
            <div className="flex items-center space-x-3">
                <LeftIcon
                    className="cursor-pointer"
                    width={16}
                    height={15}
                    onClick={close}
                />
                <h3 style={{ color: "#0466C8" }}>Markdown editor</h3>
            </div>

            <div className="flex items-center space-x-7" style={{ fontWeight: 600, fontSize: "12px" }}>
                {isCheckedIn && (
                    <>
                        <button
                            style={{ color: "#505F7B" }}
                            onClick={() => close()}
                        >
                            Cancel
                        </button>
                        <button
                            style={{
                                height: "26px",
                                width: "50px",
                                color: "#FFF",
                                backgroundColor: "#052f35 ",
                                borderRadius: 3
                            }}
                            onClick={() => {
                                let event = new KeyboardEvent("keydown", {
                                    key: "s",
                                    code: "KeyS",
                                    ctrlKey: true,
                                });
                                document.dispatchEvent(event);
                                onChange(markdownData);
                                close();
                            }}
                        >
                            <span>Save</span>
                        </button>
                    </>
                )}
                {!isVisibleTars ? <img onClick={(() => { setIsVisibleTars(true) })} style={{ cursor: "pointer", height: "38px", width: "38px" }} src={TarsIcon} alt=""></img> : null}
            </div>
        </div>
    );
};

interface IEditor {
    source: string;
    where: string;
    type: any;
    isCheckedIn?: boolean;
    customdef?: string;
    close: () => void;
    setMarkdownData: (value: any) => void;
}

const EditorPanel: React.FC<IEditor> = ({
    isCheckedIn,
    source,
    type,
    setMarkdownData,
}) => {
    const additionalOptions = {
        overviewRulerLanes: 0,
        overviewRulerBorder: false,
    };
    const instanceRef: any = useRef(null);
    const editorRef: any = instanceRef;
    const monaco = useMonaco();
    let [highlightText, setHighlightText] = useState<string>("");
    let [selectedText, setSelectedText] = useState<string>("");

    // init monaco editor
    function handleEditorDidMount(fromEditor: any) {
        editorRef.current = fromEditor;
        if (!fromEditor) return;
        const disposable = fromEditor.onDidChangeCursorPosition(onMouseDown);
        return () => {
            disposable.dispose(); 
        };
    }
    
    const onMouseDown = (e: any) => {
        const editor = editorRef.current;
        let position = editor.getPosition();
        const selection = editor.getSelection();
        const lineNumber = position.lineNumber;
        const selectedContent = editor.getModel().getValueInRange(selection);
        const lineContent = editor.getModel().getLineContent(lineNumber);
        if (!lineContent) {
            setHighlightText("")
        }else if (lineContent.startsWith("######")) {
            setHighlightText("H6")
        }else if (lineContent.startsWith("#####")) {
            setHighlightText("H5")
        }else if (lineContent.startsWith("####")) {
            setHighlightText("H4")
        }else if (lineContent.startsWith("###")) {
            setHighlightText("H3")
        }else if (lineContent.startsWith("##")) {
            setHighlightText("H2")
        }else if (lineContent.startsWith("#")) {
            setHighlightText("H1")
        }else {
            setHighlightText("")
        }

        let hasBoldItalicStrikeCombo = false;
        let hasBoldStrikeCombo = false;
        let hasItalicStrikeCombo = false;
        let hasBoldItalicCombo = false;
        let hasBoldCombo = false;
        let hasItalicCombo = false;
        let hasStrikeCombo = false;

        if (selectedContent) {
            hasBoldItalicStrikeCombo = selectedContent.includes("***~~") && selectedContent.includes("~~***");
            hasBoldStrikeCombo = selectedContent.includes("**~~") && selectedContent.includes("~~**");
            hasItalicStrikeCombo = selectedContent.includes("*~~") && selectedContent.includes("~~*");
            hasBoldItalicCombo = selectedContent.includes("***") && selectedContent.includes("***");
            hasBoldCombo = selectedContent.includes("**") && selectedContent.includes("**") && !hasBoldItalicStrikeCombo && !hasBoldItalicCombo;
            hasItalicCombo = selectedContent.includes("*") && selectedContent.includes("*") && !hasBoldItalicStrikeCombo && !hasBoldItalicCombo;
            hasStrikeCombo = selectedContent.includes("~~") && selectedContent.includes("~~") && !hasBoldItalicStrikeCombo;
        } else {
            setSelectedText("");
        }

        // Set the selected text based on the combinations
        if (hasBoldItalicStrikeCombo) {
            setSelectedText("BOLD_ITALIC_STRIKE");
        } else if (hasBoldStrikeCombo) {
            setSelectedText("BOLD_STRIKE");
        } else if (hasItalicStrikeCombo) {
            setSelectedText("ITALIC_STRIKE");
        } else if (hasBoldItalicCombo) {
            setSelectedText("BOLD_ITALIC");
        } else if (hasBoldCombo) {
            setSelectedText("BOLD");
        } else if (hasItalicCombo) {
            setSelectedText("ITALIC");
        } else if (hasStrikeCombo) {
            setSelectedText("STRIKE");
        } else {
            setSelectedText("");
        }
    };

    useEffect(() => {
        const editor = editorRef.current;
        if (!editor) return;
        const disposable = editor.onDidChangeCursorPosition(onMouseDown);
        return () => {
            disposable.dispose(); 
        };
    }, [monaco]);

    function handleChange (e: any){
        const editor = editorRef.current;
        setMarkdownData(e);
        const disposable = editor.onMouseDown(onMouseDown);
        return () => {
            disposable.dispose(); 
        };
    }

    function handleWidget(proFrom: string) {
        const editor = editorRef?.current;
        if (!editor) return;
    
        const selection = editor.getSelection();
        const text = editor.getModel().getValueInRange(selection);
        const position = editor.getPosition();
        const lineNumber = position.lineNumber;
        const lineContent = editor.getModel().getLineContent(lineNumber);
    
        const markdownCommands: Record<string, string | (() => string | null)> = {
            BOLD: () => {
                const newText = text.includes("**") ? text.replace(/\*\*/g, '') : `**${text}**`;
                return newText;
            },
            ITALIC: () => {
                const newText = text.includes("*") ? text.replace(/\*/g, '') : `*${text}*`;
                return newText;
            },
            STRIKE: () => {
                const newText = text.includes("~~") ? text.replace(/~~/g, '') : `~~${text}~~`;
                return newText;
            },
            H1: () => {
                const headingContent = lineContent.replace(/^[\s#]+/, "").trimStart();
                const newText = highlightText === "H1" ? headingContent : `# ${headingContent}`;
                setHighlightText(highlightText === "H1" ? "" : "H1");
                return newText;
            },
            H2: () => {
                const headingContent = lineContent.replace(/^[\s#]+/, "").trimStart();
                const newText = highlightText === "H2" ? headingContent : `## ${headingContent}`;
                setHighlightText(highlightText === "H2" ? "" : "H2");
                return newText;
            },
            H3: () => {
                const headingContent = lineContent.replace(/^[\s#]+/, "").trimStart();
                const newText = highlightText === "H3" ? headingContent : `### ${headingContent}`;
                setHighlightText(highlightText === "H3" ? "" : "H3");
                return newText;
            },
            H4: () => {
                const headingContent = lineContent.replace(/^[\s#]+/, "").trimStart();
                const newText = highlightText === "H4" ? headingContent : `#### ${headingContent}`;
                setHighlightText(highlightText === "H4" ? "" : "H4");
                return newText;
            },
            H5: () => {
                const headingContent = lineContent.replace(/^[\s#]+/, "").trimStart();
                const newText = highlightText === "H5" ? headingContent : `##### ${headingContent}`;
                setHighlightText(highlightText === "H5" ? "" : "H5");
                return newText;
            },
            H6: () => {
                const headingContent = lineContent.replace(/^[\s#]+/, "").trimStart();
                const newText = highlightText === "H6" ? headingContent : `###### ${headingContent}`;
                setHighlightText(highlightText === "H6" ? "" : "H6");
                return newText;
            },
            UL: () => addList(text.trim(), "*"),
            OL: () => addList(text.trim(), "number"),
            CODE: () => {
                const enableCheck = text.includes("```")
                    ? text.replace(/^(\s*\n)?```\n?/g, '')
                        .replace(/```\n?(\s*\n)?$/g, '')
                        .trim()
                    : `\n\`\`\`\n${text}\n\`\`\`\n`;
                return enableCheck
            },
            LINK: () => {
                let linkText = `${text}[${"`"} ${"`"}]( )`;
                if (text && isValidUrl(text)) {
                    const domain = new URL(text).hostname.replace("www.", "");
                    linkText = `[${"`"}${domain}${"`"}](${text})`;
                }
                return linkText;
            },
            TABLE: () => '\n |  |  |\n |--|--|\n |  |  |',
        };
    
        const command = markdownCommands[proFrom];
        if (typeof command === "function") {
            const newText = command();
            if (newText && monaco) {
                const range = ['BOLD', 'ITALIC', 'STRIKE', 'UL', 'OL', 'LINK', 'TABLE', 'CODE'].includes(proFrom) ? selection : new monaco.Range(lineNumber, 1, lineNumber, lineContent.length + 1);
                editor.executeEdits("", [{
                    range: range,
                    text: newText,
                    forceMoveMarkers: true,
                }]);
            }
        }
    }

    const isValidUrl = (urlString: string) => {
        const urlPattern =
            /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
        return urlPattern.test(urlString);
    };

    const addList = (inputString: string, mode: string) => {
        const lines = inputString.split("\n");
        let isNum = mode === "number" ? true : false;
        const outputLines = lines
            .map((line, index) => {
                let ol = `${index + 1}.`;
                let proVal = isNum ? ol : mode;
                if (line?.slice(0, proVal.length) !== `${proVal}`) {
                    return `${proVal} ${line.trim()}`;
                } else {
                    let prefix = `${proVal} `;
                    if (line?.startsWith(prefix)) {
                        line = line.replace(prefix, "");
                    }
                    return `${line.trim()}`;
                }
            })
            .join("\n");
        return outputLines;
    };

    return (
        <>
            <div
                style={{
                    margin: "10px 18px",
                    padding: "6px 2px",
                    borderRadius: "8px",
                }}
                className="grid grid-cols-14 gap-1 bg-gray-100"
            >
                <div className="flex items-center justify-center">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("BOLD")}
                    >
                        <div className={`${selectedText?.includes("BOLD") ? "bg-gray-200" : ""}`} >
                            <BoldIcon />
                        </div>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("ITALIC")}
                    >
                        <div className={`${selectedText?.includes("ITALIC") ? "bg-gray-200" : ""}`}>
                            <ItalicIcon />
                        </div>
                    </button>
                </div>
                <div className="flex items-center justify-center border-r border-gray-300">
                    <button
                        className="rounded-sm hover:bg-gray-200 "
                        onClick={() => handleWidget("STRIKE")}
                    >
                        <div className={`${selectedText.includes("STRIKE") ? "bg-gray-200" : ""}`}>
                            <StrikeIcon />
                        </div>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        style={{
                            padding: "3px 0px",
                            lineHeight: "22px",
                        }}
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("H1")}
                    >
                        <span className= {`${highlightText=="H1" ? "bg-gray-200" : ""}`} style={{ color: "#000000", padding: "6px" }}>
                            H1
                        </span>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        style={{
                            padding: "3px 0px",
                            lineHeight: "22px",
                        }}
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("H2")}
                    >
                        <span className= {`${highlightText=="H2" ? "bg-gray-200" : ""}`} style={{ color: "#000000", padding: "6px" }}>
                            H2
                        </span>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        style={{
                            padding: "3px 0px",
                            lineHeight: "22px",
                        }}
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("H3")}
                    >
                        <span className= {`${highlightText=="H3" ? "bg-gray-200" : ""}`} style={{ color: "#000000", padding: "6px" }}>
                            H3
                        </span>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        style={{
                            padding: "3px 0px",
                            lineHeight: "22px",
                        }}
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("H4")}
                    >
                        <span className= {`${highlightText=="H4" ? "bg-gray-200" : ""}`} style={{ color: "#000000", padding: "6px" }}>
                            H4
                        </span>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        style={{
                            padding: "3px 0px",
                            lineHeight: "22px",
                        }}
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("H5")}
                    >
                        <span className= {`${highlightText=="H5" ? "bg-gray-200" : ""}`} style={{ color: "#000000", padding: "6px" }}>
                            H5
                        </span>
                    </button>
                </div>
                <div className="flex items-center justify-center border-r border-gray-300">
                    <button
                        style={{
                            padding: "3px 0px",
                            lineHeight: "22px",
                        }}
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("H6")}
                    >
                        <span className= {`${highlightText=="H6" ? "bg-gray-200" : ""}`} style={{ color: "#000000", padding: "6px" }}>
                            H6
                        </span>
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("UL")}
                    >
                        <UnorderedListIcon />
                    </button>
                </div>
                <div className="flex items-center justify-center border-r border-gray-300">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("OL")}
                    >
                        <OrderedListIcon />
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("LINK")}
                    >
                        <LinkIcon />
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("CODE")}
                    >
                        <CodeIcon />
                    </button>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className="rounded-sm hover:bg-gray-200"
                        onClick={() => handleWidget("TABLE")}
                    >
                        <TableIcon />
                    </button>
                </div>
            </div>
            <Editor
                defaultValue={source}
                language={type}
                path={type}
                height="calc(100vh - 120px)"
                line={100}
                onMount={handleEditorDidMount}
                options={{
                    fontSize: 14,
                    trimAutoWhitespace: true,
                    renameOnType: true,
                    autoIndent: "full",
                    autoClosingBrackets: "languageDefined",
                    lineNumbers: "on",
                    scrollBeyondLastLine: false,
                    readOnly: !isCheckedIn,
                    quickSuggestions: {
                        other: true,
                        comments: true,
                        strings: true,
                    },
                    parameterHints: {
                        enabled: true,
                    },
                    suggestOnTriggerCharacters: true,
                    acceptSuggestionOnEnter: "on",
                    tabCompletion: "on",
                    wordBasedSuggestions: true,
                    selectOnLineNumbers: true,
                    roundedSelection: true,
                    cursorStyle: "line",
                    minimap: {
                        enabled: false,
                    },
                    folding: false,
                    wordWrap: "on",
                    ...additionalOptions,
                }}
                keepCurrentModel={false}
                onChange={handleChange}
            />
        </>
    );
};